import React, { useState, useEffect } from "react";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc
} from "firebase/firestore";
import { db } from "../config/fbConfig";
import { useUserAuth } from "../context/UserAuthContext";
import '../styles/Product.css';
import '../styles/Classes.css';

const Notifications = () => {
  const { userData } = useUserAuth();
  const [notifications, setNotifications] = useState([]);
  const [notificationCount, setNotificationCount] = useState(0);

  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const [newNotification, setNewNotification] = useState({ title: "", body: "", audience: "All" });
  const [editingNotification, setEditingNotification] = useState(null);
  const [deletingNotification, setDeletingNotification] = useState(null);

  const fetchNotifications = async () => {
    try {
      const notificationsCollectionRef = collection(db, "notifications");
      const snapshot = await getDocs(notificationsCollectionRef);
      let list = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      // Filter notifications for non-Admin/Supreme users based on their status or 'All'
      if (userData?.status !== "Admin" && userData?.status !== "Supreme") {
        list = list.filter(notification => 
          notification.audience === userData?.status || 
          notification.audience === "All" || 
          !notification.audience
        );
      }

      setNotifications(list);
      setNotificationCount(list.length);
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  useEffect(() => {
    if (userData) {
      fetchNotifications();
    }
  }, [userData]);

  const handleAddNotification = async () => {
    try {
      await addDoc(collection(db, "notifications"), newNotification);
      setIsAddModalOpen(false);
      setNewNotification({ title: "", body: "", audience: "All" });
      fetchNotifications();
    } catch (err) {
      console.error("Error adding notification:", err);
    }
  };

  const handleEditNotification = async () => {
    try {
      await updateDoc(doc(db, "notifications", editingNotification.id), {
        title: editingNotification.title,
        body: editingNotification.body,
        audience: editingNotification.audience
      });
      setIsEditModalOpen(false);
      setEditingNotification(null);
      fetchNotifications();
    } catch (err) {
      console.error("Error updating notification:", err);
    }
  };

  const handleDeleteNotification = async () => {
    try {
      await deleteDoc(doc(db, "notifications", deletingNotification.id));
      setIsDeleteModalOpen(false);
      setDeletingNotification(null);
      fetchNotifications();
    } catch (err) {
      console.error("Error deleting notification:", err);
    }
  };

  return (
    <>
      {userData?.isActive !== false && (
      <div className="form-items big-page-items" style={{ marginTop: "-10px" }}>
        <p className="login-heading page-heading page-heading-d align-center justify-center">
          {notificationCount} NOTIFICATION(S)
        </p>

        {(userData?.status === "Admin" || userData?.status === "Supreme") && (
            <div className="justify-center">
              <button className="login-button login-button-d caps" style={{marginTop: '-10px', marginBottom: '10px'}} onClick={() => setIsAddModalOpen(true)}>
                ADD NOTIFICATION
              </button>
            </div>
        )}

        <div className="column scroll-fixed scroll-fixed1 padding-bottom-d">
          {notifications.map(notification => (
            <div key={notification.id} className="info-item info-item2 scrollable">
              <span className="font-blue-cash bold">{notification.title}</span>
              {(userData?.status === "Admin" || userData?.status === "Supreme") && (
                <span className="size5 font-blue" style={{ marginLeft: '10px' }}>
                  ({notification.audience || 'All'})
                </span>
              )}
              <br />
              <span className="size5" style={{ lineHeight: "1.4rem" }}>
                {notification.body}
              </span>

              {(userData?.status === "Admin" || userData?.status === "Supreme") && (
                <div className="row align-center justify-center gap-15" style={{float: 'right', marginTop: '10px'}}>
                  <button
                    className="list-btn"
                    onClick={() => {
                      setEditingNotification(notification);
                      setIsEditModalOpen(true);
                    }}
                  >
                    <i className="fas fa-edit"></i>
                  </button>
                  <button
                    className="list-btn delete-btn"
                    onClick={() => {
                      setDeletingNotification(notification);
                      setIsDeleteModalOpen(true);
                    }}
                  >
                    <i className="fas fa-trash"></i>
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
      )}

      {/* ADD MODAL */}
      {isAddModalOpen && (
        <div className="modal">
          <div className="modal-content">
            <h3 className="align-center modal-heading">Add Notification</h3>
            <input
              type="text"
              className="input-field"
              placeholder="Title"
              value={newNotification.title}
              onChange={e =>
                setNewNotification({ ...newNotification, title: e.target.value })
              }
            />
            <textarea
              className="input-field"
              placeholder="Body"
              rows="4"
              value={newNotification.body}
              onChange={e =>
                setNewNotification({ ...newNotification, body: e.target.value })
              }
            />
            <select
              className="input-field"
              value={newNotification.audience}
              onChange={e =>
                setNewNotification({ ...newNotification, audience: e.target.value })
              }
            >
              <option value="All">All</option>
              <option value="Staff">Staff</option>
              <option value="Cashier">Cashier</option>
              <option value="Accountant">Accountant</option>
            </select>
            <div className="row align-center gap-1">
              <button className="login-button" onClick={() => setIsAddModalOpen(false)}>
                Cancel
              </button>
              <button className="login-button" onClick={handleAddNotification}>
                Add
              </button>
            </div>
          </div>
        </div>
      )}

      {/* EDIT MODAL */}
      {isEditModalOpen && editingNotification && (
        <div className="modal">
          <div className="modal-content">
            <h3 className="align-center modal-heading">Edit Notification</h3>
            <input
              type="text"
              className="input-field"
              value={editingNotification.title}
              onChange={e =>
                setEditingNotification({ ...editingNotification, title: e.target.value })
              }
            />
            <textarea
              className="input-field"
              rows="4"
              value={editingNotification.body}
              onChange={e =>
                setEditingNotification({ ...editingNotification, body: e.target.value })
              }
            />
            <select
              className="input-field"
              value={editingNotification.audience || "All"}
              onChange={e =>
                setEditingNotification({ ...editingNotification, audience: e.target.value })
              }
            >
              <option value="All">All</option>
              <option value="Staff">Staff</option>
              <option value="Cashier">Cashier</option>
              <option value="Accountant">Accountant</option>
            </select>
            <div className="row align-center gap-1">
              <button className="login-button" onClick={() => setIsEditModalOpen(false)}>
                Cancel
              </button>
              <button className="login-button" onClick={handleEditNotification}>
                Save
              </button>
            </div>
          </div>
        </div>
      )}

      {/* DELETE CONFIRMATION MODAL */}
      {isDeleteModalOpen && deletingNotification && (
        <div className="modal">
          <div className="modal-content">
            <h2 className="modal-heading">Delete Notification</h2>
            <p className="modal-heading">Are you sure you want to delete <strong>'{deletingNotification.title}'</strong>?</p>            
            <div className="row align-center gap-1">
              <button className="login-button" onClick={() => setIsDeleteModalOpen(false)}>
                Cancel
              </button>
              <button className="login-button" onClick={handleDeleteNotification}>
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Notifications;